import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Alert, Box, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import {
  COLOR_SUPPLIERS_SIGNED_UP,
  NETWORK_GROWTH_FOOTNOTES,
} from 'components/reports/Metrics/constants/NetworkGrowth'
import { VehicleTypeFilter } from 'generated/graphql'

import { useNetworkGrowthQueryInput } from './useNetworkGrowthQueryInput'

export const NetworkGrowthFootnote = () => {
  const { input } = useNetworkGrowthQueryInput()
  const isFilteredByVehicle = input.vehicleType !== VehicleTypeFilter.All

  return (
    <Stack spacing={1} mt={3}>
      {isFilteredByVehicle && (
        <Alert severity='info'>
          Vehicle type is attributed differently per metric. Supplier sign-ups are classified by the
          supplier&rsquo;s registered fleet; job counts and distributions are classified by the
          vehicle type recorded on each job. Totals across the two are therefore not directly
          comparable under a vehicle filter.
        </Alert>
      )}

      <Stack
        direction='row'
        spacing={1.25}
        alignItems='flex-start'
        sx={{
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: alpha(COLOR_SUPPLIERS_SIGNED_UP, 0.04),
          border: 1,
          borderColor: alpha(COLOR_SUPPLIERS_SIGNED_UP, 0.2),
        }}>
        <InfoOutlinedIcon sx={{ fontSize: 18, color: COLOR_SUPPLIERS_SIGNED_UP, mt: 0.25 }} />
        <Box>
          {NETWORK_GROWTH_FOOTNOTES.map((line) => (
            <Typography
              key={line}
              variant='caption'
              color='text.secondary'
              display='block'
              sx={{ lineHeight: 1.7 }}>
              {line}
            </Typography>
          ))}
        </Box>
      </Stack>
    </Stack>
  )
}
